import { API } from "../constant/apiConstant";

export async function logoutAdminSession() {
  const response = await fetch(`${API.BASE_URL}/api/admin/auth/logout`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    }
  });

  return response.json();
}
